export default __webpack_public_path__ + "static/media/5.95d84a8f.jpg";